import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';

const styles = theme => ({
    spacer: {
        marginTop: 25,
        marginBottom: 25
    },
    imgSizer: {
        maxHeight: 220
    }
});



class AssetImagePreview extends Component {
    render() {
        const { asset_url, classes } = this.props

        if (this.props.full_page) {
            return (
                <div style={{ maxHeight: '600px' }}>
    
                    <img 
                    src={asset_url}
                    alt=''/>
                </div>
            )
        }
        return (
            <div className={classNames(classes.spacer)}>

                <img className={classNames(classes.imgSizer)} 
                src={asset_url}
                alt=''/>
            </div>
        )
        // if (this.props.full_page) {
        //     return (
        //         <div>
        //             <Grid container spacing={24}>
        //                 <Grid item xs={3}>
        //                 </Grid>
        //                 <Grid item xs={6}>
        //                     <img className={classNames(classes.imgSizer)}
        //                         // style={{ width: '100%', height: '55vh' }}
        //                         scr={asset_url}
        //                         alt=''
        //                     />
        //                 </Grid>
        //             </Grid>
        //         </div>
        //     )
        // }

        // else {
        //     return (
        //         <div className={classNames(classes.spacer)}>

        //             <img className={classNames(classes.imgSizer)} 
        //             src={asset_url}
        //             alt=''/>
        //         </div>
        //     )
        // }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetImagePreview)));


// WEBPACK FOOTER //
// src/main/content/asset/AssetImagePreview.js